import React from "react";

export default function DesktopIcon({
  title,
  style,
  className = "",
  glyphVariant = "default",
  onOpen,
  ...props
}) {
  return (
    <button
      type="button"
      className={`mac-icon ${className}`.trim()}
      style={style}
      onClick={onOpen}
      {...props}
    >
      <span
        className={`mac-iconGlyph mac-iconGlyph--${glyphVariant}`}
        aria-hidden="true"
      />
      <span className="mac-iconLabel">{title}</span>
    </button>
  );
}

